module.exports = __webpack_public_path__ + "img/listening.a46c24c9.svg";